module.exports = __webpack_public_path__ + "40106b1948d80647deeb425c82aa063b.png";